import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface AdminWorldUsersListItem {
	userId: string;
	email: string;
	name: string | null;
	worldRole: string;
	isOwner: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface AdminWorldUsersListResponse {
	world: {
		id: string;
		name: string;
		status: string;
		ownerId: string;
	};
	users: AdminWorldUsersListItem[];
}

@Injectable({ providedIn: 'root' })
export class AdminWorldUsersService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string): Observable<AdminWorldUsersListResponse> {
		return this.http.get<AdminWorldUsersListResponse>(`${environment.api.baseUrl}/v1/admin/worlds/${worldId}/users`);
	}

	add(worldId: string, email: string, role: 'member' | 'gm'): Observable<{ ok: true } | any> {
		return this.http.post(`${environment.api.baseUrl}/v1/admin/worlds/${worldId}/users`, {
			Email: email,
			Role: role,
		});
	}

	updateRole(worldId: string, userId: string, role: 'member' | 'gm'): Observable<{ ok: true } | any> {
		return this.http.patch(`${environment.api.baseUrl}/v1/admin/worlds/${worldId}/users/${userId}/role`, {
			Role: role,
		});
	}

	remove(worldId: string, userId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/admin/worlds/${worldId}/users/${userId}`);
	}
}
